import {apiRequest} from '.'

export const addHoliday = async (token, data) =>{
    try{
        const response = await apiRequest({
            url: '/holiday',
            method: 'POST',
            data,
            token
        })

        return response
    }catch(error){
        console.log(error)
    }
}

export const getAllHolidays = async (token) =>{
    try{
        const response = await apiRequest({
            url: '/holiday',
            token
        })

        return response
    }catch(error){
        console.log(error)
    }
}

export const updateHoliday = async (token, data, id) =>{
    try{
        const response = await apiRequest({
            url: `/holiday:${id}`,
            method: 'PUT',
            data,
            token
        })

        return response
    }catch(error){
        console.log(error)
    }
}

export const deleteHoliday = async (token, id) =>{
    try{
        const response = await apiRequest({
            url: `/holiday${id}`,
            method:'DELETE',
            token
        })

        return response
    }catch(error){
        console.log(error)
    }
}